import * as httpx from "httpx"
import * as events from "./events"
import { CancellablePromise } from "real-cancellable-promise"
import {
	DocumentSearchRequest,
	DocumentSearchResponse,
	DocumentFindResponse,
	DocumentPatchRequest,
	DocumentPatchResponse,
	DocumentUploadResponse,
} from "brandguard/brandguard.document_pb"

export function upload(
	data: FormData,
	file: File,
	bid: string,
	...options: httpx.option[]
): CancellablePromise<DocumentUploadResponse> {
	data.append("content", file)
	return httpx
		.upload<DocumentUploadResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/training`, data, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages || [],
		}))
}

export function search(
	req: DocumentSearchRequest,
	bid: string,
	...options: httpx.option[]
): CancellablePromise<DocumentSearchResponse> {
	return httpx
		.get<DocumentSearchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/training`, req, ...options)
		.then((resp) => ({
			...resp,
			items: (resp.items || []).map((item) => ({
				media: item.media,
				event: events.zero(item.event),
				pages: item.pages || [],
			})),
		}))
}

export function find(id: string, bid: string, ...options: httpx.option[]): CancellablePromise<DocumentFindResponse> {
	return httpx
		.get<DocumentFindResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/training/${id}`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages || [],
		}))
}

export function patch(
	bid: string,
	id: string,
	req: DocumentPatchRequest,
	...options: httpx.option[]
): Promise<DocumentPatchResponse> {
	return httpx
		.patch<DocumentPatchResponse>(
			`${httpx.urlstorage.host()}/brands/${bid}/bg/document/training/${id}`,
			req,
			...options,
		)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages || [],
		}))
}

export function requeue(id: string, bid: string, ...options: httpx.option[]): Promise<DocumentFindResponse> {
	return httpx
		.post<DocumentFindResponse>(
			`${httpx.urlstorage.host()}/brands/${bid}/bg/document/training/${id}/requeue`,
			{},
			...options,
		)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages || [],
		}))
}

export function destroy(bid: string, id: string, ...options: httpx.option[]): Promise<DocumentPatchResponse> {
	return httpx
		.destroy<DocumentPatchResponse>(
			`${httpx.urlstorage.host()}/brands/${bid}/bg/document/training/${id}`,
			{},
			...options,
		)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages || [],
		}))
}
